import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IInitialState, RootState } from '../../../reduxService';
import { IProjectInfoForm } from '../../pages/ProjectInfo/IProjectInfo';
// import { EProjectType, unit } from '../../enum/project'; // Not currently used
//import { setProjectValidationSchema } from '../../Dynamic/store/project/projectslice';

type IProjectInfoState = IInitialState<IProjectInfoForm>;

const initialState: IProjectInfoState = {
    initialState: true,
    data: {
        unit: '',
        designerFirmCity: '',
        owner: '',
        designerFirmName: '',
        designerFirmCountry: '',
        projectName: '',
        projectType: '',
        coordinates: [undefined, undefined],
        productCountry: null,
        nrProject: '0',
        notes: '',
        geogridHasBeenRan: false,
    },
};

export const projectInfoSlice = createSlice({
    name: 'projectInfo',
    initialState,
    reducers: {
        cleanProjectInfo: state => {
            state.initialState = true;
            state.data = undefined;
        },
        setProjectInfo: (state, action: PayloadAction<IProjectInfoForm>) => {
            state.initialState = !action.payload.projectId;
            state.data = action.payload;
        },
        setProjectInfoTemplate: (state, action: PayloadAction<IProjectInfoForm>) => {
            state.initialState = false;
            state.data = { ...action.payload, ...state.data, projectType: action.payload.projectType, unit: action.payload.unit };
        },
        setFormValidationSchema: (state, action: PayloadAction<any>) => {
            state.initialState = false;
            state.data = { ...state.data, validationSchema: action.payload } as IProjectInfoForm;
        },
    },
});

export const { setProjectInfo, cleanProjectInfo, setProjectInfoTemplate, setFormValidationSchema } = projectInfoSlice.actions;

export const selectProjectInfo = (state: RootState) => state.projectInfo;
export const selectDynamic = (state: RootState) => state.Dynamic;
export const selectDynamicProject = (state: RootState) => state.Dynamic.project?.data;
export const selectProjectData = (state: RootState) => state.Dynamic.project?.data?.projectInfo;

export default projectInfoSlice.reducer;
